/**
 * O vocabulário da exportação em fila (2026-10-15) — espelho de
 * `core.vocabulary` (`EXPORT_KINDS`, `EXPORT_FORMATS`, `EXPORT_STATUSES`
 * e os subconjuntos ativo/terminal), com paridade travada por
 * `tests/test_export_vocabulary_parity.py` (lê este arquivo, inclusive a
 * SEQUÊNCIA). Os mapas de rótulo são tipados sobre as tuplas de
 * propósito: chave a menos ou a mais é erro de compilação, não uma linha
 * sem nome na tela.
 */

export const EXPORT_KINDS = [
  "export_report",
  "export_upload_rows",
  "export_mentions",
  "export_draft"
] as const;
export type ExportKind = (typeof EXPORT_KINDS)[number];

export const EXPORT_FORMATS = ["xlsx", "csv"] as const;
export type ExportFormat = (typeof EXPORT_FORMATS)[number];

/** Como saem tema e subtema na planilha: uma coluna por tema (`columns`,
 *  o padrão) ou as duas colunas "Tema" e "Subtemas" (`pair`). Espelho de
 *  `EXPORT_THEME_LAYOUTS` em `core/vocabulary.py`. */
export const EXPORT_THEME_LAYOUTS = ["columns", "pair"] as const;
export type ExportThemeLayout = (typeof EXPORT_THEME_LAYOUTS)[number];

export const EXPORT_STATUSES = [
  "QUEUED",
  "STARTED",
  "FINISHED",
  "ERRORED",
  "EXPIRED"
] as const;
export type ExportStatus = (typeof EXPORT_STATUSES)[number];

/** Ainda andando: a página faz polling enquanto houver um. */
export const EXPORT_ACTIVE_STATUSES = ["QUEUED", "STARTED"] as const;

export const EXPORT_KIND_LABELS: Record<ExportKind, string> = {
  export_report: "Amostra",
  export_upload_rows: "Planilha do upload",
  export_mentions: "Menções",
  export_draft: "Rascunho de amostra"
};

export const EXPORT_FORMAT_LABELS: Record<ExportFormat, string> = {
  xlsx: "Excel (.xlsx)",
  csv: "CSV (.csv)"
};

export const EXPORT_STATUS_LABELS: Record<ExportStatus, string> = {
  QUEUED: "Na fila",
  STARTED: "Gerando…",
  FINISHED: "Pronta",
  ERRORED: "Falhou",
  EXPIRED: "Expirada"
};

export function isExportActive(status: string): boolean {
  return (EXPORT_ACTIVE_STATUSES as readonly string[]).includes(status);
}

/** Acima disto a tela sugere CSV (decisão 7 do plano: o Excel abre mas
 *  rasteja). */
export const EXPORT_CSV_SUGGESTION_ROWS = 100_000;

/** Tamanho estimado do arquivo por linha, medido nas exportações da SECOM
 *  (2026-10-15): ~0,5 KB/linha em xlsx e ~1 KB/linha em CSV (47 mil linhas
 *  deram 22,9 MB e 47,2 MB). Só alimenta o aviso da tela. */
export const EXPORT_BYTES_PER_ROW: Record<ExportFormat, number> = {
  xlsx: 500,
  csv: 1000
};
